import {useFormik} from 'formik'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import * as Yup from 'yup'
import {initTicketAssignFormValues} from '../_model'
import {useEffect} from 'react'
import {BASE_URL} from '../../config'
import axios from 'axios'
import toast from 'react-hot-toast'
import {useMutation, useQueryClient} from 'react-query'
import {useRittApp} from '../../../utils/contextProvider/RittAppProvider'
import OptimizedSelectBox from '../../../utils/components/OptimizedSelectBox'

const ASSIGN_TICKET_URL = `${BASE_URL}/api/protect/assignedToTeam`

type Props = {
  assignTicketId: number | null
  onResetAssignTicket: () => void
}

const assignSchema = Yup.object().shape({
  username: Yup.string().required('Username is required'),
})

const AssignTicket = ({assignTicketId, onResetAssignTicket}: Props) => {
  const queryClient = useQueryClient()
  const {userInfo} = useRittApp()

  const {mutate: assignTicketToUser} = useMutation({
    mutationKey: ['ticketList'],
    mutationFn: async ({ticketId, userId}: {ticketId: number; userId: number}) => {
      const response = await axios.post<{
        message: string
        status: string
        statuscode: number
      }>(ASSIGN_TICKET_URL, null, {
        params: {ticketId, userId},
      })
      return response.data
    },
    onSuccess: (values) => {
      toast.dismiss()
      toast.success(values.message)
      onResetAssignTicket()
      queryClient.invalidateQueries(['ticketList'])
      formik.resetForm()
    },
    onError: (error: Error) => {
      toast.dismiss()
      toast.error(error.message)
    },
  })

  const formik = useFormik({
    initialValues: initTicketAssignFormValues,
    validationSchema: assignSchema,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')

        if (assignTicketId && values.userId) {
          await assignTicketToUser({ticketId: assignTicketId, userId: values.userId})
        }
      } catch (error) {
        console.log(error)
      }
    },
  })

  const onSelectUser = (id: number) => formik.setFieldValue('userId', id)

  useEffect(() => {
    console.log(assignTicketId)
  }, [assignTicketId])

  return (
    <div className='modal fade' tabIndex={-2} id='kt_modal_2'>
      <div className='modal-dialog modal-xl'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Assign Ticket</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit}>
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-5 mb-2'>Userame</label>

                <OptimizedSelectBox
                  formik={formik}
                  fieldValue='username'
                  placeholder='Select assign user'
                  setSelect={onSelectUser}
                  options={userInfo}
                />

                {formik.touched.username && formik.errors.username && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.username}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  className='btn btn-light me-4'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Close
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssignTicket
